import { createAsyncActionTypes, preloadScript } from '@mews/framework';
import { createBackgroundAction } from '@mews-commander/utils';
import prefix from '../prefix';
import { getAssetBaseUrl } from '../reducers/configuration';

const PREFETCH = prefix('PREFETECH');
export const [PREFETCH_STARTED, PREFETCH_SUCCEEDED, PREFETCH_FAILED] = createAsyncActionTypes(PREFETCH);

export const prefetchAssets =
    (assetVersion: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { loggerService }: $TSFixMe) => {
        const baseUrl = getAssetBaseUrl();
        const commanderScriptUrl = `${baseUrl}/${assetVersion}/commander.js`;

        const promise = preloadScript(commanderScriptUrl).catch((error) => {
            loggerService.log('script-load-error', 'New Commander version could not be loaded.', {
                error,
            });
        });
        return dispatch(createBackgroundAction(PREFETCH, promise));
    };
